import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66ef4cc7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 me-3" }, "Công ty: ...........................................", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Chi nhánh: ...........................................", -1))
const _hoisted_3 = { class: "text-center fw-bolder text-uppercase" }
const _hoisted_4 = {
  class: "text-center mb-1 fst-italic",
  style: {"font-size":"0.8rem"}
}
const _hoisted_5 = {
  class: "text-center mb-0",
  style: {"font-size":"0.9rem"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-end mb-0 fst-italic",
  style: {"font-size":"0.8rem"}
}, "ĐVT: đồng", -1))
const _hoisted_7 = {
  class: "d-flex justify-content-between mx-5 align-items-end",
  style: {"font-size":"0.8rem"}
}
const _hoisted_8 = { class: "flex flex-column justify-content-end align-items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-center my-2 fst-italic",
  style: {"font-size":"0.8rem"}
}, " Ngày ..... tháng ..... năm ..... ", -1))

import { computed, getCurrentInstance, PropType, ref } from 'vue';
import { ButtonsType } from '@/core/enums/buttons.enums';
import { IKhoResponseBase, ITongHopVatTuResponseBase } from '@/core/interfaces/ApiResponses';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import DivCol from '@/layout/_shared/DivCol.vue';
import DivRow from '@/layout/_shared/DivRow.vue';
import SignatureCol from '@/layout/_shared/SignatureCol.vue';
import TongHopVatTuTable from '../table-components/TongHopVatTuTable.vue';

const modalId = 'modal-id-print-modal';


export default /*#__PURE__*/_defineComponent({
  __name: 'TongHopVatTuPrintModal',
  props: {
  from: {
    type: Date,
    default: new Date(),
  },
  isTongHopNhap: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  items: {
    type: Array as PropType<ITongHopVatTuResponseBase[]>,
    default: () => ([]),
  },
  kho: {
    type: Object as PropType<IKhoResponseBase | null>,
    default: null,
  },
  to: {
    type: Date,
    default: new Date(),
  },
},
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const app = getCurrentInstance();

const onPrintingButtonClicked = () => {
  (app.appContext.config.globalProperties as any).$htmlToPaper(modalId);
}

const isOpen = ref(false);

__expose({
  isOpen,
});

const dateDisplay = computed(() => {
  if (props.from.getMonth() === props.to.getMonth() + 1) return `Tháng ${props.from.getMonth() + 1} năm ${props.from.getFullYear()}`

  return `Từ tháng ${props.from.getMonth() + 1} năm ${props.from.getFullYear()} đến tháng ${props.to.getMonth() + 1} năm ${props.to.getFullYear()}`
});

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    title: `TỔNG HỢP ${__props.isTongHopNhap ? 'NHẬP' : 'XUẤT'} VẬT TƯ`,
    width: "90%",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createVNode(DivRow, { class: "mb-2" }, {
        default: _withCtx(() => [
          _createVNode(DivCol, { cols: 10 }),
          _createVNode(DivCol, {
            cols: 2,
            class: "text-end justify-content-end"
          }, {
            default: _withCtx(() => [
              _createVNode(ButtonCustom, {
                "button-type": _unref(ButtonsType).FA_PRINT,
                onClick: onPrintingButtonClicked
              }, {
                "button-label": _withCtx(() => [
                  _createTextVNode("In phiếu")
                ]),
                _: 1
              }, 8, ["button-type"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        id: modalId,
        class: "printing-paper"
      }, [
        _createVNode(DivRow, { class: "row mb-3" }, {
          default: _withCtx(() => [
            _createVNode(DivCol, {
              cols: 10,
              style: {"font-size":"0.8rem","font-weight":"700"}
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(DivRow, { class: "mb-3" }, {
          default: _withCtx(() => [
            _createVNode(DivCol, { cols: 3 }),
            _createVNode(DivCol, { cols: 6 }, {
              default: _withCtx(() => [
                _createElementVNode("h6", _hoisted_3, " bảng kê chi tiết " + _toDisplayString(__props.isTongHopNhap ? 'NHẬP' : 'XUẤT'), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(dateDisplay.value), 1),
                _createElementVNode("p", _hoisted_5, "Nhập tại kho: " + _toDisplayString(__props.kho?.ten_kho), 1)
              ]),
              _: 1
            }),
            _createVNode(DivCol, { cols: 3 })
          ]),
          _: 1
        }),
        _hoisted_6,
        _createVNode(DivRow, null, {
          default: _withCtx(() => [
            _createVNode(DivCol, { cols: 12 }, {
              default: _withCtx(() => [
                _createVNode(TongHopVatTuTable, {
                  "is-tong-hop-nhap": __props.isTongHopNhap,
                  items: __props.items
                }, null, 8, ["is-tong-hop-nhap", "items"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createVNode(SignatureCol, { "nguoi-ky": "Thủ kho" })
          ]),
          _createElementVNode("div", null, [
            _createVNode(SignatureCol, { "nguoi-ky": "Người giữ sổ" })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(SignatureCol, { "nguoi-ky": "TP Tài Chính" })
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})